import { useState } from "react";
import { useQuestions } from "../../QuestionStore";

export function LinkBlock({ item, onDelete, width }) {
    const [draft, setDraft] = useState("");
    const { addItemToCurrentQuestion } = useQuestions();

    const handleConfirm = () => {
        const result = identifyAndConvertLink(draft);
        if (result.media === "unknown") {
            // show an error, toast, etc.
            return;
        }
        addItemToCurrentQuestion(result);
        onDelete();
    };


    return (
        <div
            style={{
                width,
                boxSizing: "border-box",
                padding: "14px 16px",
                borderRadius: 10,
                background: "#ffffff",
                border: "1.5px solid #e8e8e8",
                boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
                flexShrink: 0,
            }}
        >
            <input
                type="url"
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                placeholder="Paste link here…"
                style={{
                    width: "100%",
                    boxSizing: "border-box",
                    fontSize: 13,
                    color: "#2d2d2d",
                    border: "1.5px solid #e0e0e0",
                    borderRadius: 7,
                    padding: "8px 10px",
                    outline: "none",
                    fontFamily: "monospace",
                    background: "#fafafa",
                }}
            />

            <div
                style={{
                    display: "flex",
                    gap: 8,
                    marginTop: 10,
                    justifyContent: "flex-end",
                }}
            >
                <button
                    onClick={onDelete}
                    style={{
                        fontSize: 12,
                        padding: "5px 14px",
                        borderRadius: 6,
                        border: "1.5px solid #e0e0e0",
                        background: "#fff",
                        color: "#666",
                        cursor: "pointer",
                    }}
                >
                    Cancel
                </button>
                <button
                    onClick={handleConfirm}
                    style={{
                        fontSize: 12,
                        padding: "5px 14px",
                        borderRadius: 6,
                        border: "none",
                        background: "#2d2d2d",
                        color: "#fff",
                        cursor: "pointer",
                    }}
                >
                    OK
                </button>
            </div>
        </div>
    );
}


function identifyAndConvertLink(url) {
    const trimmed = url.trim();

    // --- YouTube ---
    // handles: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/shorts/ID
    const ytMatch = trimmed.match(
        /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    if (ytMatch) {
        return {
            media: "video",
            res: {
                url: `https://www.youtube.com/embed/${ytMatch[1]}`,
                local: false,
                provider: "youtube",
            },
        };
    }

    // --- Vimeo ---
    // handles: vimeo.com/ID
    const vimeoMatch = trimmed.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) {
        return {
            media: "video",
            res: {
                url: `https://player.vimeo.com/video/${vimeoMatch[1]}`,
                local: false,
                provider: "vimeo",
            },
        };
    }

    // --- Direct video file ---
    if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(trimmed)) {
        return {
            media: "video",
            res: {
                url: trimmed,
                local: false,
                provider: "direct",
            },
        };
    }

    // --- Direct image file ---
    if (/\.(jpg|jpeg|png|gif|webp|svg|bmp)(\?.*)?$/i.test(trimmed)) {
        return {
            media: "image",
            res: {
                url: trimmed,
                local: false,
                provider: "direct",
            },
        };
    }

    // --- Fallback: unknown ---
    return {
        media: "unknown",
        res: {
            url: trimmed,
            local: false,
            provider: null,
        },
    };
}